import { useState } from 'react';
import content from '../content.json';

export default function Reviews() {
  const [active, setActive] = useState(0);
  const reviews = content.reviews;

  const prev = () => setActive((active - 1 + reviews.length) % reviews.length);
  const next = () => setActive((active + 1) % reviews.length);

  return (
    <section style={{ background: 'var(--dark)', padding: '120px 0', position: 'relative', overflow: 'hidden' }}>
      {/* Background texture */}
      <div style={{ position:'absolute',inset:0,backgroundImage:'url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTAgMTBoNDBNMCAyMGg0ME0wIDMwaDQwTTEwIDBoMTBWNDBNMjAgMGgxMFY0MCIgc3Ryb2tlPSJyZ2JhKDI1NSwyNTUsMjU1LDAuMDMpIiBmaWxsPSJub25lIi8+PC9zdmc+)',backgroundSize:'40px' }} />

      <div style={{ maxWidth: '860px', margin: '0 auto', padding: '0 48px', textAlign: 'center', position: 'relative', zIndex: 1 }}>
        <div className="reveal" style={{ marginBottom: '56px' }}>
          <span className="section-label">Testimonials</span>
          <h2 className="section-title" style={{ color: 'var(--offwhite)' }}>What Our Guests <em style={{ color: 'var(--gold2)' }}>Have to Say</em></h2>
          <div className="gold-line center" />
        </div>

        <div className="reveal delay-1">
          {/* Quote mark */}
          <div style={{ fontSize: '64px', fontFamily: 'Georgia', color: 'var(--gold)', lineHeight: 0.8, marginBottom: '28px', opacity: 0.6 }}>"</div>

          {/* Review text */}
          <p style={{ fontFamily:'var(--font-title)',fontStyle:'italic',fontSize:'clamp(1rem,1.8vw,1.25rem)',color:'rgba(248,245,240,0.9)',lineHeight:1.75,marginBottom:'36px',minHeight:'120px',transition:'opacity 0.3s' }}>
            {reviews[active].text}
          </p>

          <div style={{ width:'32px',height:'1px',background:'var(--gold)',margin:'0 auto 20px' }} />
          <p style={{ fontFamily:'var(--font-body)',fontSize:'11px',letterSpacing:'0.25em',textTransform:'uppercase',color:'var(--gold2)',marginBottom:'4px' }}>{reviews[active].author}</p>
          <p style={{ fontFamily:'var(--font-body)',fontSize:'11px',color:'rgba(248,245,240,0.4)',letterSpacing:'0.1em' }}>{reviews[active].type}</p>
        </div>

        {/* Navigation arrows */}
        <div style={{ display:'flex',alignItems:'center',justifyContent:'center',gap:'24px',marginTop:'48px' }}>
          <button onClick={prev} style={{ background:'none',border:'1px solid rgba(200,150,60,0.3)',cursor:'pointer',color:'var(--gold2)',fontSize:'20px',width:'44px',height:'44px',display:'flex',alignItems:'center',justifyContent:'center',transition:'all 0.2s' }}
            onMouseEnter={e=>{e.currentTarget.style.borderColor='var(--gold)';e.currentTarget.style.color='var(--gold)';}}
            onMouseLeave={e=>{e.currentTarget.style.borderColor='rgba(200,150,60,0.3)';e.currentTarget.style.color='var(--gold2)';}}
          >‹</button>
          <div style={{ display:'flex',gap:'8px' }}>
            {reviews.map((_,i) => (
              <button key={i} onClick={() => setActive(i)} style={{ width:i===active?'24px':'6px',height:'1px',background:i===active?'var(--gold)':'rgba(200,150,60,0.3)',border:'none',cursor:'pointer',transition:'all 0.3s',padding:0 }} />
            ))}
          </div>
          <button onClick={next} style={{ background:'none',border:'1px solid rgba(200,150,60,0.3)',cursor:'pointer',color:'var(--gold2)',fontSize:'20px',width:'44px',height:'44px',display:'flex',alignItems:'center',justifyContent:'center',transition:'all 0.2s' }}
            onMouseEnter={e=>{e.currentTarget.style.borderColor='var(--gold)';e.currentTarget.style.color='var(--gold)';}}
            onMouseLeave={e=>{e.currentTarget.style.borderColor='rgba(200,150,60,0.3)';e.currentTarget.style.color='var(--gold2)';}}
          >›</button>
        </div>
      </div>
    </section>
  );
}
